import { render, staticRenderFns } from "./MainLayoutHeader.vue?vue&type=template&id=f6f902f6&scoped=true&"
import script from "./MainLayoutHeader.vue?vue&type=script&lang=ts&"
export * from "./MainLayoutHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MainLayoutHeader.vue?vue&type=style&index=0&id=f6f902f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f902f6",
  null
  
)

export default component.exports